import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export interface UserBo {
  email?: string;
  first_name?: string;
  last_name?: string;
  roles?: string[];
}

export const useUpdateUserBo = () => {
  const queryClient = useQueryClient();

  const updateUser = async ({
    customerId,
    userId,
    data
  }: {
    customerId: number;
    userId: string;
    data: UserBo;
  }) => {
    const response = await Axios.patch<UserBo>(
      `${POST_URL(customerId.toString(), userId).updateUserBo}`,
      data
    );
    return response.data;
  };

  return useMutation<
    UserBo,
    AxiosError<BaseError>,
    { customerId: number; userId: string; data: UserBo }
  >(
    ({ customerId, userId, data }) => updateUser({ customerId, userId, data }),
    {
      onSuccess: (_, { customerId }) => {
        queryClient.invalidateQueries(['customerBoIam', customerId]);
      },
      useErrorBoundary: false
    }
  );
};
